import React, { useCallback, useState } from 'react';

import SuperBatchModuleAsyncSelect from 'pages/ManageMenteeModulesPage/SuperBatchModuleAsyncSelect';
import styles from './SuperBatchModuleInput.module.scss';

export default function SuperBatchModuleInput({
  superBatch,
  onChange,
  disabled = false,
}: ISuperBatchModuleInput) {
  const [superBatchModule, setSuperBatchModule] =
    useState<IAcademyModuleChangeOption | null>(null);

  const handleAcademyModuleChange = useCallback(
    (option: IAcademyModuleChangeOption) => {
      setSuperBatchModule(option);
      onChange({
        academy_module_id: option?.value,
        academy_module_name: option?.label,
        super_batch_module_id: option?.super_batch_module,
      });
    },
    [onChange]
  );

  return (
    <div className="row">
      <SuperBatchModuleAsyncSelect
        superBatch={superBatch}
        value={superBatchModule}
        onChange={handleAcademyModuleChange}
        className={styles.input}
      />
    </div>
  );
}
